import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-chatter-message',
  templateUrl: './chatter-message.component.html',
  styleUrls: ['./chatter-message.component.scss']
})
export class ChatterMessageComponent implements OnInit, AfterViewInit {
  @Input()
  public message: string;

  @Input()
  public field: string = undefined;

  @Input()
  public origin: string = 'system';

  @Input()
  public variables: any;

  @Output()
  public messageRendered: EventEmitter<void> = new EventEmitter<void>();

  public domInserted: boolean = false;

  public ngOnInit(): void {
    this.message = this.interpolate(this.message, this.variables);
  }

  public ngAfterViewInit(): void {
    this.messageRendered.emit();
    setTimeout(() => {
      this.domInserted = true;
    }, 0);
  }

  private interpolate(message: string, variables?: any): string {
    if (variables && message && message.replace) {
      for (const key in variables) {
        if (variables[key]) {
          if (this.field) {
            message = message.replace(key, this.variables[key][this.field]);
          } else {
            message = message.replace(key, this.variables[key]);
          }
        }
      }
      return message;
    } else {
      return message;
    }
  }
}
